"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SamplingSchema = exports.SampleAllSamplingSchema = exports.CriteriaSamplingSchema = exports.CriteriaSamplingConfigSchema = exports.AssetConfigSchema = exports.FieldConfigSchema = exports.AssetVerificationOutput = exports.StoredDocumentation = void 0;
const zod_1 = require("zod");
// Re-export namespaces as modules
exports.StoredDocumentation = __importStar(require("./AssetVerification/StoredDocumentation"));
exports.AssetVerificationOutput = __importStar(require("./AssetVerification/AssetVerificationOutput"));
exports.FieldConfigSchema = zod_1.z.object({
    receivableResponseTapeField: zod_1.z
        .string()
        .describe('Where in receivable response tape is this field?'),
    receivableDocumentionField: zod_1.z
        .string()
        .describe('Where in generated pdf answers is this field?'),
    comparisonFormula: zod_1.z
        .string()
        .describe('How should we compare. This formula can access baseFields/intermediateFields and documentation fields.'),
});
exports.AssetConfigSchema = zod_1.z.object({
    fields: zod_1.z.array(exports.FieldConfigSchema).describe('Fields to verify'),
});
exports.CriteriaSamplingConfigSchema = zod_1.z.object({
    name: zod_1.z.string().describe('Unique name for the criteria'),
    formula: zod_1.z.string().describe('Formula that resolves to boolean'),
    percentageRate: zod_1.z.number().optional().describe('Defaults to 1 if undefined'),
    maximum: zod_1.z
        .number()
        .optional()
        .describe('Maximum amount to sample, if undefined, no max is enforced'),
});
exports.CriteriaSamplingSchema = zod_1.z.object({
    type: zod_1.z.literal('criteria'),
    config: zod_1.z.object({
        criterion: zod_1.z
            .array(exports.CriteriaSamplingConfigSchema)
            .describe('Each criteria is independent, allows for multiple "buckets"'),
    }),
});
exports.SampleAllSamplingSchema = zod_1.z.object({
    type: zod_1.z.literal('sampleAll'),
    name: zod_1.z.string(),
});
exports.SamplingSchema = zod_1.z.discriminatedUnion('type', [
    exports.CriteriaSamplingSchema,
    exports.SampleAllSamplingSchema,
]);
//# sourceMappingURL=AssetVerification.js.map